// Central app configuration derived from environment variables.
// Gatsby exposes variables prefixed with GATSBY_ to the browser.

console.log("Backend API Base URL:", process.env.GATSBY_LIFEFORCE_API_BASE);

export const HENNOS_POST_URL = `${process.env.GATSBY_LIFEFORCE_API_BASE}/api/hennos/event`;
export const HENNOS_SSE_URL = `${process.env.GATSBY_LIFEFORCE_API_BASE}/api/hennos/events`;
export const HENNOS_HISTORY_URL = `${process.env.GATSBY_LIFEFORCE_API_BASE}/api/hennos/history`;
export const HENNOS_SEARCH_URL = `${process.env.GATSBY_LIFEFORCE_API_BASE}/api/search`;
